import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom"
import "./navbar.scss"

function Navbar() {

    useEffect(() => {
        var menuOpen=false
        // const navBtnDiv = document.querySelector('.nav-btn-div')
        const navBtn = document.querySelector('.nav-btn')
        const menu = document.querySelector('.nav-menu')
        const links = document.querySelectorAll('.menu-link')
        // menu.style.pointerEvents = "all"
        navBtn.addEventListener("click", handleMenu)
        

        links.forEach((link) => {
            link.addEventListener("click", () => {
                menu.style.opacity="0" 
                menu.style.pointerEvents = "none"
                document.querySelector('body').style.overflow = 'auto';
                
                menuOpen=!menuOpen
            })
        })

        function handleMenu(){
            if(menuOpen){
                menu.style.opacity="0" 
                menu.style.pointerEvents = "none"
                document.querySelector('body').style.overflow = 'auto';                
            }
            else {
                menu.style.opacity="1"
                menu.style.pointerEvents = "all"
                document.querySelector('body').style.overflow = 'hidden';
            }
            
            menuOpen=!menuOpen
        }

    },[])


    return (
        <>  
            <div className='nav-btn-div'>
                <button className='nav-btn'>
                    <span className='slash'>/</span>
                    <span className='slash'>/</span>
                    <span className='slash'>/</span>
                </button>
            </div>
            <div className='nav-menu'>
                <div className='links-wrapper'>
                   <Link className='fade-in-anim menu-link' to={'/'}><span></span>home</Link>
                    <Link className='fade-in-anim menu-link' to={'/projects'}><span></span>projects</Link>
                    <Link className='fade-in-anim menu-link' to={'/about'}><span></span>about</Link>
                    <Link className='fade-in-anim menu-link' to={'/skills'}><span></span>skills</Link>
                    <Link className='fade-in-anim menu-link' to={'/contact'}><span></span>contact</Link>
                    
                    <div className='social-links'>
                        <a href='https://www.linkedin.com/in/aprameya-shankar-44523a239/' rel='noreferer' name="LinkedIn">
                            <span className='block-anim'>LinkedIn</span>
                        </a>
                        <a href='https://github.com/Aprameya-S' rel='noreferer' name="Github">
                            <span className='block-anim'>Github</span>
                        </a>
                        <a href='mailto:aprameyashankar@gmail.com' rel='noreferer' name="Email">
                            <span className='block-anim'>Email</span>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )    
}
export default Navbar;